import { Box, CircularProgress, Grid, TextField, Typography } from '@hiiretail/react-foundation-ui';
import { ReceiptFormData, VATSummary } from 'common/receipt.types';
import { isPositiveNumber } from 'common/utils/isPositiveNumber';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

interface VATSummaryRowProps {
  index: number;
  row: VATSummary;
  rate: string | null;
  isLoading: boolean;
  error: any;
}

export const VATSummaryRow: FC<VATSummaryRowProps> = ({ index, row, rate, isLoading, error }) => {
  const intl = useIntl();

  const {
    control,
    formState: { errors },
  } = useFormContext<ReceiptFormData>();

  const required = intl.formatMessage({ id: 'receipt.input.required' });

  return (
    <Grid container key={JSON.stringify(row)} mb={1} columnSpacing={1}>
      <Grid item xs={5}>
        <Controller
          name={`VATSummary.${index}.basePrice`}
          control={control}
          rules={{ required, validate: { isPositiveNumber } }}
          render={({ field }) => (
            <TextField
              placeholder={intl.formatMessage({ id: 'receipt.input.placeholder' })}
              type="number"
              size="small"
              {...field}
              error={!!errors.VATSummary?.[index]?.basePrice}
              helperText={errors.VATSummary?.[index]?.basePrice?.message}
            />
          )}
        />
      </Grid>
      <Grid item xs={5}>
        <Controller
          name={`VATSummary.${index}.VATAmount`}
          control={control}
          rules={{ required, validate: { isPositiveNumber } }}
          render={({ field }) => (
            <TextField
              placeholder={intl.formatMessage({ id: 'receipt.input.placeholder' })}
              type="number"
              size="small"
              {...field}
              error={!!errors?.VATSummary?.[index]?.VATAmount}
              helperText={errors?.VATSummary?.[index]?.VATAmount?.message}
            />
          )}
        />
      </Grid>
      <Box px={3} pt={1} flex={1}>
        {isLoading && <CircularProgress size={20} />}
        {error ? <Typography>{row.taxableGroupId}</Typography> : <Typography>{rate}</Typography>}
      </Box>
    </Grid>
  );
};
